import { render } from "./InitialLoading.vue?vue&type=template&id=0147a6c9"
import script from "./InitialLoading.vue?vue&type=script&lang=js"
export * from "./InitialLoading.vue?vue&type=script&lang=js"
script.render = render

export default script